import React, {useEffect, useState, useRef, useCallback} from 'react';
import {useParams} from "react-router-dom"
import Tree from './tree.js'
import PermanentLinkButton from "./link";

export default function Styleguide() {

    const [tree, setTree] = useState([]);
    const [loading, setLoading] = useState(false);
    const [authentification, setAuthentification] = useState('');
    useRef('');
    const [ready, setReady] = useState('');
    const [error, setError] = useState('');
    const [lHeaders, setLHeaders] = useState(new Headers());

    let {styleguideId} = useParams();
    let warning = ""

    const loadStyleguide = useCallback((authHeaders, id) => {
        setLoading(true);
        setLHeaders(authHeaders); // Speichert die Header für den Link-Button

        fetch('/api/guides/' + id, {method: 'GET', headers: authHeaders})
            .then(response => {
                if (response.status === 200) {
                    return response.json();
                } else {
                    throw new Error("Die Anmeldung war nicht korrekt.");
                }
            })
            .then(data => {
                setError("");
                setTree(data);
                setReady(id);
                setLoading(false);
            })
            .catch(error => {
                console.error('Fehler beim Abrufen der Daten.', error);
                setLoading(false);
                setReady("");
                setError(error.message || "Fehler beim Abrufen der Daten.");
            });
    }, []);

    useEffect(() => {
        setReady("");
        setTree(null);
        setError("");
        setAuthentification("");
        setLHeaders(null);
    }, [styleguideId]);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        const urlStyleguideId = urlParams.get('styleguideId');

        if (token && urlStyleguideId) {
            const authHeaders = {
                'Authorization': 'Basic ' + btoa(`token#${urlStyleguideId}:` + token)
            };

            loadStyleguide(authHeaders, urlStyleguideId);
            const newUrl = window.location.pathname;
            window.history.replaceState({}, document.title, newUrl);
        }
    }, [loadStyleguide]);

    const handleLogin = () => {
        if (!authentification || !styleguideId) return;

        const authHeaders = {
            'Authorization': 'Basic ' + btoa(styleguideId + ":" + authentification)
        };

        loadStyleguide(authHeaders, styleguideId);
        setAuthentification("");
    };

    if (error != null && error !== "") {
        warning = <div className="m-2 alert alert-danger d-flex align-items-center" role="alert">{error}</div>
    }


    if (loading) {

        return <div className="card" id="styleguide">
            <div className="card-header">
                <p>Lade Styleguide {styleguideId}</p>
                <div className="spinner-border text-primary" role="status">
                    <span className="sr-only"></span>
                </div>
            </div>
        </div>
    }

    if (ready !== styleguideId) {
        return <div className="card" id="styleguide">
            <div className="card-header">
                <h2>{styleguideId}</h2>
            </div>
            {warning}
            <div className="card-body">
                <form onSubmit={(e) => {
                    e.preventDefault();
                    handleLogin();
                }}>
                    <div className="mb-3 d-flex flex-column">
                        <label htmlFor="login" className="form-label align-self-start">Passwort:</label>

                        <input
                            id="login"
                            className="form-control align-self-start"
                            type="password"
                            name="login"
                            value={authentification}
                            onChange={event => setAuthentification(event.target.value)}
                        />

                        <small id="emailHelp" className="form-text text-muted align-self-start mt-1">
                            Bitte geben Sie das Passwort für diesen Styleguide an.
                        </small>
                    </div>

                    <div className="d-flex flex-column">
                        <button type="submit" className="btn btn-primary align-self-start">Anmelden</button>
                    </div>
                </form>
            </div>
        </div>
    }


    return (
        <div className="card" id="styleguide">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h2>{styleguideId}</h2>
                <PermanentLinkButton sStyleguidesValue={styleguideId} headers={lHeaders}/>
            </div>
            <div className="card-body">
                <Tree rootName={styleguideId} treeData={tree} headers={lHeaders}/>
            </div>
        </div>
    )
}